<template>
    <div class="no-data">
      <div class="no-data-content">
        <div class="no-data-icon"><i class="el-icon-folder-opened"></i></div>
        <div class="no-data-text">暂无数据</div>
      </div>

    </div>
</template>

<script>
export default {
  name: 'NoData',
  data () {
    return {
      iconUrl: require('../../assets/no_data.jpg')
    }
  }
}
</script>

<style scoped>
.no-data{
  text-align: center;
}
.no-data-content {
  width: 380px;
  height: 180px;
  margin: auto;
  border: 2px dashed #ccc;
  border-radius: 5px;
  padding-top: 20px;
}
.no-data-icon {
  font-size: 100px;
  color: #cccccc;
}
.no-data-text {
  font-size: 20px;
  color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/components/NoData/NoData.vue